<div class="d-flex flex-column">
  <div class="d-flex proposal-details-row">
    <div class="info-col">{{'createProposal.countryWithLocalPolicies' | translate}}:</div>

    <div *ngIf="proposal">
      <ng-container
        *ngFor="let countryName of proposal.proposalInformation.countriesWithLocalPolicies;let first = first">
        <ng-container *ngIf="!first">{{', '}}</ng-container>
        {{ countryName }}</ng-container>
    </div>
  </div>
</div>
